module.exports = "<div class=\"modal-content\">\n  <div class=\"modal-header text-center\">\n    <h4 class=\"modal-title\">{{modalHeader}}</h4>\n  </div>\n  <div class=\"modal-body\">\n    {{message}}\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" (click)=\"doYes()\">Si</button>\n    <button class=\"btn btn-success\" (click)=\"doNo()\">No</button>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/modals/components/modalConfirm/modalConfirm.html
// module id = ../../../../../src/app/theme/components/modals/components/modalConfirm/modalConfirm.html
// module chunks = 14